export default "__VITE_ASSET__bd7e7ba9__"